import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { NAV_BRAND } from '@/config'
import PropTypesHelpers from '@/utils/propTypesHelpers'

const NavBrandWrapper = ({ className, children }) => {
  if (NAV_BRAND.is_linked) {
    return (
      <a
        className={classnames('nav-brand', `nav-brand-${NAV_BRAND.portal_type}`, className)}
        href='/' aria-label={NAV_BRAND.title}
      >
        {children}
      </a>
    )
  }
  return (
    <div className={classnames('nav-brand', `nav-brand-${NAV_BRAND.portal_type}`, className)}>
      {children}
    </div>
  )
}

NavBrandWrapper.propTypes = {
  className: PropTypesHelpers.classnames,
  children: PropTypes.node
}

const NavBrand = ({ className }) => {
  return (
    <NavBrandWrapper className={className}>
      <div className='logo-wrapper'>
        <img
          src={NAV_BRAND.logo}
          className={NAV_BRAND.portal_type === 'yf' ? 'desktop' : ''}
          title={`${NAV_BRAND.subtitle} | ${NAV_BRAND.title}`}
          alt={`${NAV_BRAND.subtitle} | ${NAV_BRAND.title}`}
          width='226'
          height='64'
          loading='lazy'
        />
      </div>
      {NAV_BRAND.portal_type === 'yf' &&
        <img
          src={NAV_BRAND.logo_mobile}
          className='mobile'
          title={`${NAV_BRAND.subtitle} | ${NAV_BRAND.title}`}
          alt={`${NAV_BRAND.subtitle} | ${NAV_BRAND.title}`}
          width='119'
          height='30'
        />}

      {NAV_BRAND.portal_type !== 'yf' &&
        <div className='logo-glyph'>
          <p className='logo'>
            {NAV_BRAND.title}
            <small>{NAV_BRAND.subtitle}</small>
          </p>
          <p className='claim'>{NAV_BRAND.claim}</p>
        </div>}
    </NavBrandWrapper>
  )
}

NavBrand.propTypes = {
  className: PropTypesHelpers.classnames
}

export default NavBrand
